// extracted by mini-css-extract-plugin
module.exports = {"McsInputLabel":"McsInput_McsInputLabel__3S4B3","McsInputMaxLength":"McsInput_McsInputMaxLength__fR5T8"};